import { Props } from 'shared/@types';
import { Footer } from './footer';
import { Menu } from './menu';
import { View } from 'react-native';
import { Tabs } from './tabs';
import { useUIVisibility } from 'shared/state/ui-visibility';
import { useCurrentRoute } from 'shared/library/routes/route';
import dynamic from 'next/dynamic';
import { DeferredClientRender } from './deferred-client-render';
import { useUserStore } from 'shared/state/user';
import { Activity } from 'react';
import { useGuestPromoScroll } from '@web/library/use-guest-promo-scroll';

const ShopMenu = dynamic(() => import('./shop-menu').then((mod) => mod.ShopMenu), {
  loading: () => <div className={'h-[var(--header-h)]'} />,
});
const GlobalLoginModal = dynamic(
  () => import('@web/components/global-login-modal').then((mod) => mod.GlobalLoginModal),
  { ssr: false },
);
const GuestPromoModal = dynamic(
  () => import('shared/components/guest-promo-modal').then((mod) => mod.GuestPromoModal),
  { ssr: false },
);
const UserOnboardingModal = dynamic(
  () =>
    import('shared/components/onboarding/user-onboarding-modal').then(
      (mod) => mod.UserOnboardingModal,
    ),
  { ssr: false },
);
const DataSharingRepromptModal = dynamic(
  () =>
    import('shared/components/data-sharing-reprompt-modal').then(
      (mod) => mod.DataSharingRepromptModal,
    ),
  { ssr: false },
);

export default function Layout({ children }: Props) {
  const isLoggedIn = useUserStore((state) => state.user !== null);
  const hasScrolled = useGuestPromoScroll(!isLoggedIn);
  const { hideFooterOnMobile } = useUIVisibility();
  const currentRoute = useCurrentRoute();
  const isShopRoute = currentRoute.name.startsWith('shop.');

  return (
    <View className={isShopRoute ? 'shop-layout' : 'marketplace-layout'}>
      <View className={`z-auto flex min-h-screen w-full flex-col overflow-x-clip`}>
        {isShopRoute ? <ShopMenu /> : <Menu />}

        {children}

        <Activity mode="visible">
          {hideFooterOnMobile ? (
            <View className={'hidden md:flex'}>
              <Footer />
            </View>
          ) : (
            <Footer />
          )}
        </Activity>
      </View>

      {!isShopRoute && <Tabs />}

      <DeferredClientRender timeout={2000}>
        <GlobalLoginModal />

        {isLoggedIn && (
          <>
            <UserOnboardingModal />
            <DataSharingRepromptModal />
          </>
        )}

        <GuestPromoModal hasScrolled={hasScrolled} />
      </DeferredClientRender>
    </View>
  );
}
